

import React, { forwardRef, useEffect, useState } from "react";
import moment from "moment";
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import AttachEmailSharpIcon from '@mui/icons-material/AttachEmailSharp';
import LinkSharpIcon from '@mui/icons-material/LinkSharp';
// import logo22 from "../../assets/images/logo22.png"



const ResumePdf = forwardRef(({
    userDataInfo,
    userCertification,
    userExperience,
    userAwards,
    projectData,
    userSkill,
    userEducation,
}, ref) => {

    console.log('userDataInfo==>', userDataInfo);
    console.log("Image URL:", userDataInfo?.userImage);
    console.log('userSkillsss', userSkill);

    // Apply the filter on new variables instead of overwriting props
    const filteredEducation = userEducation?.filter((item) => !item.isDeleted && item.status === 1);
    const filteredExperience = userExperience?.filter((item) => !item.isDeleted && item.status === 1);
    const filteredCertification = userCertification?.filter((item) => !item.isDeleted && item.status === 1);
    const filteredAwards = userAwards?.filter((item) => !item.isDeleted && item.status === 1);
    const filtereprojectData = projectData?.filter((item) => !item.isDeleted && item.status === 1);

    console.log("filteredEducation", filteredEducation, filteredExperience);

    return (
        <>
            <div
                id="pdfContent" // Add an ID for targeting
                ref={ref}
                style={{
                    width: "1200px",
                    minHeight: "auto",
                    height: "auto", // Ensure height is flexible
                    overflow: "visible",
                    backgroundColor: "white",
                    padding: "20px",
                    marginBottom: "20px",
                    marginLeft: "40px",
                    marginRight: "40px",
                    marginTop: "20px",
                    fontFamily: "PlusJakartaSans-Regular",
                    pageBreakInside: "avoid",
                    display: "block",
                    overflow: "hidden"
                }}

                class="resumepdf" >
                <section style={{ pageBreakInside: "avoid" }} className="pdf-section">
                    <h1 className="mb-3 f-700 text-center">Candidate Resume (Jobkikhoj)</h1>

                    <div className="resuem-main-img">
                        <img className="text-center" src={userDataInfo?.userImage || ""} alt="User Logo" />
                    </div>

                    <header className="text-center" >
                        {userDataInfo?.fullName === null ? "" : (
                            <h1>{userDataInfo.fullName}</h1>
                        )}
                        {userDataInfo?.fullName === null ? "" : (
                            <h5></h5>
                        )}
                        {userDataInfo?.dsgntnName === null ? "" : (
                            <p>{userDataInfo.dsgntnName}</p>
                        )}

                       
                        <p>
                         {userDataInfo?.email === null ? "" : (
                            <span>Email: {userDataInfo.email}   </span>
                          )}   ||  
                            {userDataInfo?.phoneNumber === null ? "" : (
                             <span>PhoneNumber: {userDataInfo.phoneNumber }</span>     
                            )}
                            </p>
                        
                        <p>
                         {userDataInfo?.dob === null ? "" : (
                             <span>Date Of Birth: {moment(userDataInfo.dob).format("DD MMM YYYY")} </span>     
                            )} ||
                            {userDataInfo?.dob === null ? "" : (
                             <span>Language: {userDataInfo.languages.join(", ") }</span>     
                            )}
                            </p>

                         {userDataInfo?.address === "" ? "" : (
                            <>
                                <p>{userDataInfo.address}</p>
                            </>
                        )}

                        {userDataInfo?.about === "" ? "" : (
                            <>
                                <p>{userDataInfo.about}</p>
                            </>
                        )}

                    </header>
                    {/* {userExperience.length === 0 ? (
                        "") :
                        ( */}
                </section>


                {filteredExperience.length > 0 && (
                    <>
                        {/* Experience Section Header */}
                        <section className="pdf-section">
                            <h2>Experience</h2>
                        </section>

                        {/* Each Experience Entry */}
                        {filteredExperience.map((exp, index) => (
                            <section className="pdf-section" key={exp.id || index}>
                                <div className="job mb-3" style={{ pageBreakInside: "avoid" }}>
                                    {/* Job Title, Date, Company */}
                                    <h4>{exp.jobTitle} ({exp.positionHeadline})</h4>
                                    <p>
                                        <span className="f-600">{exp.companyName}</span>
                                        {exp.cityName && <> (At {exp.cityName}) </>}
                                        ({moment(exp.startDate).format("DD MMM YYYY")})
                                        {exp.endDate ? <> - ({moment(exp.endDate).format("DD MMM YYYY")})</> : " - Present"}
                                    </p>

                                    {/* Description */}
                                    {exp.description?.trim() && (
                                        <ul><li>{exp.description}</li></ul>
                                    )}

                                    {/* Experience Roles */}
                                    {exp.usrDataExperienceRoles?.length > 0 && (
                                        <div className="ms-3">
                                            <h3 className="mb-2 pb-2"><span className="border-bottom1">Experience Role</span></h3>
                                            {exp.usrDataExperienceRoles
                                                .filter(item => !item.isDeleted)
                                                .map((role, i) => (
                                                    <ul key={role.id || i}>
                                                        <li style={{ lineHeight: ".5" }}>{role.role}</li>
                                                    </ul>
                                                ))}
                                        </div>
                                    )}

                                    {/* Experience Achievements */}
                                    {exp.usrDataExperienceAchievements?.length > 0 && (
                                        <div className="ms-3">
                                            <h3 className="mb-2 pb-2"><span className="border-bottom1">Experience Achievements</span></h3>
                                            {exp.usrDataExperienceAchievements
                                                .filter(item => !item.isDeleted)
                                                .map((ach, i) => (
                                                    <ul key={ach.id || i}>
                                                        <li style={{ lineHeight: ".5" }}>
                                                            {ach.achievement}
                                                            {ach.achivementDate && <> ({moment(ach.achivementDate).format("DD MMM YYYY")})</>}
                                                        </li>
                                                    </ul>
                                                ))}
                                        </div>
                                    )}
                                </div>
                            </section>
                        ))}
                    </>
                )}


                {filteredEducation.length > 0 && (
                    <>
                        {/* Education Section Header */}
                        <section className="pdf-section">
                            <h2>Education</h2>
                        </section>

                        {/* Each Education Entry */}
                        {filteredEducation.map((edu, index) => (
                            <section className="pdf-section" key={edu.id || index}>
                                <div className="job mb-3" style={{ pageBreakInside: "avoid" }}>
                                    {/* Qualification, Institution, Date */}
                                    <h4>{edu.qualification} ({edu.specilization})</h4>
                                    <p>
                                        <span className="f-600">{edu.institutionName}</span>
                                        {edu.cityName && <> (At {edu.cityName})</>}
                                        {edu.startYear && (
                                            <> ({moment(edu.startMonth).format("MMM")} {moment(edu.startYear).format("YYYY")}) </>
                                        )}
                                        {edu.isPresent ? (
                                            "- Present"
                                        ) : (
                                            <> - ({moment(edu.endMonth).format("MMM")} {moment(edu.endYear).format("YYYY")})</>
                                        )}
                                    </p>

                                    {/* Description */}
                                    {edu.description && <p>{edu.description}</p>}

                                    {/* Education Activities */}
                                    {edu.usrDataEducationActivities?.length > 0 && (
                                        <div className="ms-3">
                                            <h3 className="mb-2 pb-2"><span className="border-bottom1">Education Activity</span></h3>
                                            {edu.usrDataEducationActivities
                                                .filter(item => !item.isDeleted)
                                                .map((eduact, i) => (
                                                    <ul key={eduact.id || i}>
                                                        <li className="mb-0" style={{ lineHeight: ".5" }}>{eduact.activity}</li>
                                                    </ul>
                                                ))}
                                        </div>
                                    )}

                                    {/* Education Achievements */}
                                    {edu.usrDataEducationAchievements?.length > 0 && (
                                        <div className="ms-3">
                                            <h3 className="mb-2 pb-2"><span className="border-bottom1">Education Achievements</span></h3>
                                            {edu.usrDataEducationAchievements
                                                .filter(item => !item.isDeleted)
                                                .map((eduach, i) => (
                                                    <ul key={eduach.id || i}>
                                                        <li className="mb-0 f-500" style={{ lineHeight: ".5" }}>
                                                            {eduach.achievement}
                                                            {eduach.achivementDate && (
                                                                <> ({moment(eduach.achivementDate).format("DD MMM YYYY")})</>
                                                            )}
                                                        </li>
                                                    </ul>
                                                ))}
                                        </div>
                                    )}
                                </div>
                            </section>
                        ))}
                    </>
                )}



                {filteredAwards.length > 0 && (
                    <section className="pdf-section">
                        {/* Awards Section Header */}
                        <h2>Awards</h2>

                        {/* Awards List */}
                        {filteredAwards.map((awrd, index) => (
                            <div className="job" key={awrd.id || index} style={{ pageBreakInside: "avoid" }}>
                                {/* Award Title and Recognition */}
                                <h3>{awrd.name} ({awrd.recognition})</h3>

                                {/* Location and Date */}
                                <p>
                                    {awrd.cityName && <> (At {awrd.cityName}) </>}
                                    {awrd.issueDate && <>({moment(awrd.issueDate).format("DD MMM YYYY")})</>}
                                </p>

                                {/* Description */}
                                {awrd.description?.trim() && (
                                    <ul><li>{awrd.description}</li></ul>
                                )}
                            </div>
                        ))}
                    </section>
                )}


                {filteredCertification.length > 0 && (
                    <section className="pdf-section">
                        {/* Certificates Section Heading */}
                        <h2>Certificates</h2>

                        {/* Each Certificate Entry */}
                        {filteredCertification.map((certif, index) => (
                            <div className="job" key={certif.id || index} style={{ pageBreakInside: "avoid" }}>
                                {/* Certificate Name & Recognition */}
                                <h3>{certif.name} ({certif.recognition})</h3>

                                {/* Location and Dates */}
                                <p>
                                    {certif.cityName && <> (At {certif.cityName}) </>}
                                    {certif.issueDate && <>({moment(certif.issueDate).format("DD MMM YYYY")})</>}
                                    {certif.expirationDate
                                        ? <> - ({moment(certif.expirationDate).format("DD MMM YYYY")})</>
                                        : " - Present"}
                                </p>

                                {/* Certificate Description */}
                                {certif.description?.trim() && (
                                    <ul>
                                        <li>{certif.description}</li>
                                    </ul>
                                )}
                            </div>
                        ))}
                    </section>
                )}



                {userSkill?.filter(skill => !skill.isDeleted).length > 0 && (
                    <section className="pdf-section" style={{ pageBreakBefore: "always" }}>
                        {/* Skills Header */}
                        <h2>Skills</h2>

                        {/* Skill Items */}
                        {userSkill
                            .filter(skill => !skill.isDeleted)
                            .map((skill, index) => (
                                <div className="job" key={skill.id || index} style={{ pageBreakInside: "avoid" }}>
                                    <h3>
                                        {skill.skillName}
                                        <span style={{ fontWeight: "normal" }}>
                                            ({skill.fiName})
                                        </span>
                                    </h3>
                                </div>
                            ))}
                    </section>
                )}


                {filtereprojectData.length > 0 && (
                    <section className="pdf-section">
                        <h2>Projects</h2>

                        {filtereprojectData.map((prjct, index) => (
                            <div className="job mb-3" key={prjct.id || index} style={{ pageBreakInside: "avoid" }}>
                                {/* Project Name + Associated With */}
                                <h3>
                                    {prjct.name}
                                    {prjct.associatedWith ? ` (${prjct.associatedWith})` : ''}
                                </h3>

                                {/* Project URL and Dates */}
                                <p>
                                    {prjct.projectUrl && (
                                        <>
                                            ({prjct.projectUrl})
                                        </>
                                    )}

                                    {/* Start Date */}
                                    {prjct.startYear && (
                                        <>
                                            {' '}
                                            ({moment(prjct.startMonth).format("MMM")} {moment(prjct.startYear).format("YYYY")})
                                        </>
                                    )}

                                    {/* End Date or "Currently Working" */}
                                    {prjct.endYear === null || moment(prjct.endYear).format("YYYY") === "Invalid date" ? (
                                        " - Currently working on"
                                    ) : (
                                        <>
                                            - ({moment(prjct.endMonth).format("MMM")} {moment(prjct.endYear).format("YYYY")})
                                        </>
                                    )}
                                </p>

                                {/* Project Description */}
                                {prjct.description && (
                                    <p>{prjct.description}</p>
                                )}
                            </div>
                        ))}
                    </section>
                )}
            </div>

        </>

    );


});



export default ResumePdf;
